import { UUID } from 'crypto'
import VehicleLicenseTypeRestrictions from './VehicleLicenseTypeRestrictions'
import { VehicleLicenseTypeDto } from '../../pages/users/api/dto/get/VehicleLicenseTypeDto'

class VehicleLicenseType {
  private constructor(
    id: UUID,
    vehicle: string,
    restrictions: VehicleLicenseTypeRestrictions,
    cost: number,
  ) {
    this.id = id
    this.vehicle = vehicle
    this.restrictions = restrictions
    this.cost = cost
  }

  private readonly id: UUID
  private readonly vehicle: string
  private readonly restrictions: VehicleLicenseTypeRestrictions
  private readonly cost: number

  hasId(id: string) {
    return this.id === id
  }

  getId() {
    return this.id
  }

  getType(): string {
    return this.vehicle
  }

  getImage(): string {
    return `/assets/${this.id}.svg`
  }

  static fromDto(
    vehicleLicenseTypeDto: VehicleLicenseTypeDto,
  ): VehicleLicenseType {
    return new VehicleLicenseType(
      vehicleLicenseTypeDto.id,
      vehicleLicenseTypeDto.vehicle,
      VehicleLicenseTypeRestrictions.fromDto(
        vehicleLicenseTypeDto.restrictions,
      ),
      vehicleLicenseTypeDto.cost,
    )
  }
}

export default VehicleLicenseType
